import { forgotPassword, login, resetPassword, signin } from '../api';

export const loginReq = async (body) => {
  const response = await login(body);
  return response;
};

export const signinReq = async (body) => {
  const response = await signin(body);
  return response;
};

export const forgotPasswordReq = async (body) => {
  const response = await forgotPassword(body);
  return response;
};

export const resetPasswordReq = async (body) => {
  const response = await resetPassword(body);
  return response;
};
